<template>
  <div class="template-1-width rounded-3" id="template-one-to-print">
    <div class="template-1-top"></div>
    <div class="template-1-bottom">
      <div class="row">
      <div class="col-9">
        <div class="row">
          <div class="col-12">
            <div class="my-25">
              <h4 class="black-text fw-bolder name-text text-capitalize">{{ limitText(cardInfo.full_name, 20) }}</h4>
            </div>
          </div>
          <div class="col-7">
            <div class="my-25">
              <h4 class="black-text main-text">
                <span class="fw-bolder">DOB:</span>  {{ cardInfo.format_birthday }}
              </h4>
            </div>
          </div>
          <div class="col-5">
            <div class="my-25">
              <h4 class="black-text main-text text-capitalize">
                <span class="fw-bolder"> Gender:</span> {{ cardInfo.gender }}
              </h4>
            </div>
          </div>
          <div class="col-12">
            <div class="my-25">
              <h4 class="black-text main-text">
                <div class="d-flex">
                  {{ cardInfo.serial_no }}
                  <div class="mx-2" v-html="barcode"></div>
                </div>

              </h4>
            </div>
          </div>
        </div>
      </div>
        <div class="col-3">
          <div class="profile-img">
            <img :src="cardInfo.photo" class="rounded img-fluid" alt="Card image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import handleFormatter from "@/services/utils/figureFormatter";

const props = defineProps({
  cardInfo:{
    type:Object
  },
  barcode:{
    type:String
  },
})

const {
  limitText
} = handleFormatter();

</script>

<style>
.main-text{
  font-size: 13px;
  margin: 0;
}
.name-text{
  font-size: 16px;
  margin: 0;
}
.black-text{
  --bs-text-opacity: 1;
  color: #000000 !important;
}
.template-1-width {
  width: 4.1in;
  height: 2.05in;
}
.template-1-top{
  height: 0.95in;
}
.template-1-bottom{
  height: 1.1in;
}
@media print {
  body {
    visibility: hidden;
  }

  #template-one-to-print {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
  }
  @page {
    margin: 0;
  }
}
@page {
  size: 3.4in 2.1in;
}
</style>
